import { useEffect, useCallback } from 'react';
import { useBlocker } from 'react-router-dom';

// doesn't matter, since browser will NOT display it;
// so we can pass anything - passing readable text just in case
const title = 'Are you sure you want to leave this page?';

const handleRouteChange = (event) => {
  event.preventDefault();
  event.returnValue = title;
  return title;
};

export const ConfirmNavigation = ({
  isBlocked,
  children,
  forceOpen = false,
  onCancel,
  onSubmit,
}) => {
  const shouldBlock = useCallback(
    ({ currentLocation, nextLocation }) =>
      isBlocked && currentLocation.pathname !== nextLocation.pathname,
    [isBlocked],
  );
  const blocker = useBlocker(shouldBlock);
  const isBlockedState = blocker.state === 'blocked';
  const isProceedingState = blocker.state === 'proceeding';

  useEffect(() => {
    if (isBlocked) {
      window.addEventListener('beforeunload', handleRouteChange);
    } else {
      if (isBlockedState) {
        window.removeEventListener('beforeunload', handleRouteChange);
        blocker.reset?.();
      }
    }
    return () => {
      window.removeEventListener('beforeunload', handleRouteChange);
    };
  }, [blocker, isBlocked, isBlockedState]);

  const handleSubmit = () => {
    onSubmit?.();
    blocker.proceed?.();
  };
  const handleCancel = () => {
    onCancel?.();
    blocker.reset?.();
  };

  return children({
    isBlocked,
    handleCancel,
    handleSubmit,
    isOpen: isBlockedState || isProceedingState || forceOpen,
  });
};
